export default "__VITE_ASSET__a7934d09__"